import { render, staticRenderFns } from "./registeredUsers.vue?vue&type=template&id=db798664"
import script from "./registeredUsers.vue?vue&type=script&lang=js"
export * from "./registeredUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports